

import Toolbar from 'primevue/toolbar';

import {ZIndexUtils} from "primevue/utils";
//import Helper from "../../utils/Helper";

export default {
  name: "XModal",
  emits: ['hide', 'show'],
  props: {
    hideFooter: {
      type: Boolean,
      default: false,
    },
    showOverlay: {
      type: Boolean,
      default: false,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    fullTransparent: {
      type: Boolean,
      default: false,
    },
    blurOverlay: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: String,
      default: '1',
    },
    autoshow: {
      type: Boolean,
      default: false,
    },

  },
  computed: {

    overlayClass() {

      return {
        'p-component-overlay p-component-overlay-enter': this.showOverlay,
        'blur-overlay': this.blurOverlay,
      }

    }

  },
  data() {
    return {
      //zIndex: 0,
      modalInfoVisible: false,
      overlay: null,
    }
  },
  methods: {

    isVisible() {
      return this.modalInfoVisible;
    },
    async show(forceShow = null) {

      if (!this.modalInfoVisible || forceShow) {

        document.addEventListener('keydown', this.escapeHandler);
        this.modalInfoVisible = true;

        document.body.classList.add('noScroll')

        await this.$nextTick()

        /*if (this.$el?.style && !this.$el.style.zIndex)
          this.$el.style.zIndex = (Helper.methods.maxZIndex()+1)*/

        ZIndexUtils.set('overlay', this.$el, this.$primevue.config.zIndex.overlay);
        this.$emit('show');

        return this.$el

      }

    },
    async hide() {
      document.removeEventListener('keydown', this.escapeHandler);
      this.modalInfoVisible = false;

      if (this.$el?.style?.zIndex)
        ZIndexUtils.clear(this.$el);


      let xdialogs = document.body.querySelectorAll('.xdialog');

      if (xdialogs.length === 1 && (xdialogs?.[0] === this.$el)) {
        document.body.classList.remove('noScroll')
      }
      this.$emit('hide');
    },

    escapeHandler(e) {
      if (e.key === 'Escape') {

        if (this.fullTransparent)
          return;

        //console.log(this.$el?.style?.zIndex, Helper.methods.maxZIndex().toString());
        if (this.$el?.style?.zIndex === /*Helper.methods.maxZIndex().toString()*/ ZIndexUtils.getCurrent().toString()) {
          //console.log('Hide method on ', this.$el)
          this.hide();
          e.stopImmediatePropagation();
          e.stopPropagation()
        }

      }
    }

  },
  mounted() {

    if (this.autoshow)
      this.show();

  },
  unmounted() {

  },
  components: {
    Toolbar,
  }


}
